import { isTouch } from '../_app/cuchillo/core/Basics';
import Keyboard from '../_app/cuchillo/core/Keyboard';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Header from '../layout/Header';
import Default from './Default';

export default class Home extends Default {
  constructor() {
    super();
  }

  //SHOW
  beforeShow() {
    Scroll.init(Scroll.AXIS_Y, { domResize: this.container, smooth: !isTouch, multiplicator: 1 });
    Keyboard.mountPage(this.id);
    Header.mode = Header.MODE_SHOW;
  }

  afterShow() {
    this._isActive = true;
    this._setupAnchors();

    Scroll.start();
    Scroll.show();
  }
}

ControllerPage._addPage('home', Home);
